
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music-knowledge-hub/[slug]",
      function () {
        return require("private-next-pages/music-knowledge-hub/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/music-knowledge-hub/[slug]"])
      });
    }
  